"use client";

import React, { useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { SwitchVerticalIcon } from "@/common/components/icons";
import { Button } from "@/common/components/ui/button";
import { Form, FormControl, FormField, FormItem } from "@/common/components/ui/form";
import { Input } from "@/common/components/ui/input";
import { env } from "@/env";
import { stage } from "./utils";
export const StageFormSchema = z.object({
  stageBaseUrl: z.string({
    required_error: "وارد کردن شماره کارت الزامیست."
  })
});
export type StageFormValues = z.infer<typeof StageFormSchema>;
const StagingProvider = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const formMethods = useForm<StageFormValues>({
    mode: "onChange",
    resolver: zodResolver(StageFormSchema),
    defaultValues: {
      stageBaseUrl: stage.getBaseUrl()
    }
  });
  if (!env.isStage) {
    return null;
  }
  const {
    handleSubmit
  } = formMethods;
  const onSubmit = (formValues: StageFormValues) => {
    stage.setBaseUrl(formValues.stageBaseUrl);
    setIsOpen(false);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  return <AnimatePresence mode="popLayout" data-sentry-element="AnimatePresence" data-sentry-component="StagingProvider" data-sentry-source-file="index.tsx">
      {isOpen ? <motion.div layoutId="show" transition={{
      type: "spring",
      bounce: 0.4
    }} className="absolute left-2 top-52  z-50 rounded-md bg-white p-4">
          <Form {...formMethods}>
            <form onSubmit={handleSubmit(onSubmit)} className="flex items-end justify-center gap-2">
              <div className="relative flex min-w-80 flex-col items-center gap-8">
                <FormField name="stageBaseUrl" control={formMethods.control} render={({
              field,
              fieldState
            }) => {
              return <FormItem className="w-full shrink-0 grow">
                        <div className="flex w-full cursor-pointer items-center justify-start gap-1">
                          <p className="text-sm font-medium text-gray-900">
                            آدرس جدید
                          </p>
                        </div>
                        <FormControl className="mb-0">
                          <div className="relative w-full">
                            <Input size="lg" type="text" inputMode="numeric" message={fieldState.error?.message} color={fieldState.error ? "error" : "gray"} className="mb-0 px-4" placeholder="مبلغ مورد نظر را وارد نمایید" {...field} />
                          </div>
                        </FormControl>
                      </FormItem>;
            }} />
              </div>

              <Button type="submit" className="h-auto min-h-0 gap-2 rounded-md p-3">
                <p className="text-base font-medium">تغییر</p>
              </Button>
              <Button type="button" variant="text" onClick={() => {
            setIsOpen(false);
          }} className="h-auto min-h-0 gap-2 rounded-md p-3">
                <p className="text-base font-medium">بستن</p>
              </Button>
            </form>
          </Form>
        </motion.div> : <motion.div layoutId="hide" transition={{
      type: "spring",
      bounce: 0
    }} onClick={() => {
      setIsOpen(true);
    }} className="absolute left-2 top-52 flex size-12 cursor-pointer items-center justify-center rounded-full border border-solid bg-white">
          <SwitchVerticalIcon />
        </motion.div>}
    </AnimatePresence>;
};
export default StagingProvider;